interface megamenuOptions {
  handleClick: EventListener,
  handleFocus: EventListener,
  setup: Function,
  open: Function,
  close: Function,
}

interface documentOptions {
  keydown: Function,
  click: Function,
  setup: Function
}

interface navOptions {
  activeMenu: HTMLElement|null;
  megamenu: megamenuOptions,
  document: documentOptions,
  init: Function
}

interface KeyboardEvent {
  code: string;
}

const handleDocKeydown = (evt:KeyboardEvent) => {
  if (evt.code === 'Escape') {
    // close the menu
    nav.megamenu.close()
  }
}

const handleDocClick = (evt:MouseEvent) => {
  if (!evt.target) return
  nav.megamenu.close()
}

const decorateHeader = (active:boolean) => {
  const headerwrapper:HTMLElement | null = document.querySelector('.sb-header-fixed')
  if (!headerwrapper) return
  headerwrapper.classList.toggle('full-width', active)
}

const nav:navOptions = {
  activeMenu: null,
  megamenu: {
    handleFocus: (evt:Event) => {
      evt.stopPropagation()
      nav.megamenu.close()
    },
    handleClick: (evt:Event) => {
      // stop propagation of the click event to prevent the document onclick handler from closing the menu immediately.
      evt.stopPropagation()
      console.log('nav: ', evt)

      const target = evt.target as HTMLElement
      const isActive = target.getAttribute('aria-expanded') === 'true' ? true : false

      if (isActive) {
        nav.megamenu.close(nav.activeMenu)
      } else {
        nav.megamenu.open(target)
      }
    },
    setup: () => {
      const megamenuTriggers:NodeList = document.querySelectorAll('nav.sb-c-main-nav button[aria-controls], nav.sb-mobile-nav__nav button[aria-controls]')
      megamenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', nav.megamenu.handleClick)
      })

      const mainMenuTriggers:NodeList = document.querySelectorAll('nav.sb-c-main-nav > ul > li > [role="menuitem"]')
      mainMenuTriggers.forEach((trigger) => {
        trigger.addEventListener('focus', nav.megamenu.handleFocus)
      })
    },
    open: (target:HTMLElement|null) => {
      if (target === null) return

      if (nav.activeMenu) {
        nav.megamenu.close(nav.activeMenu)
      }

      const controls = target.getAttribute('aria-controls')
      target.setAttribute('aria-expanded', "true")

      const controlled = document.querySelector(`#${controls}`)
      if (!controlled) return
      decorateHeader(false)
      if (controlled.classList.contains('sb-main-nav-full-width')) {
        decorateHeader(true)
      }
      controlled.classList.add('active')
      nav.activeMenu = target
    },
    close: (target:HTMLElement|null) => {
      if (nav.activeMenu === null) return

      let closeTarget:HTMLElement|null = target

      if (!closeTarget) {
        closeTarget = nav.activeMenu
      }

      const controls = closeTarget?.getAttribute('aria-controls')
      closeTarget?.setAttribute('aria-expanded', "false")

      const controlled = document.querySelector(`#${controls}`)
      if (!controlled) return
      decorateHeader(false)
      controlled.classList.remove('active')
      nav.activeMenu = null
    }
  },
  document: {
    keydown: () => {
      document.addEventListener('keydown' as const, handleDocKeydown)
    },
    click: () => {
      document.addEventListener('click', handleDocClick)
    },
    setup: () => {
      nav.document.keydown()
      nav.document.click()
    }
  },
  init: () => {
    nav.megamenu.setup()
    nav.document.setup()
  }
}

export default nav
